import React, { FC, useCallback, useMemo, useState } from 'react';
import { Button, Divider, Modal } from 'antd';
import Form, { FormSchema } from '@sezenta/antd-schema-form';
import { useConnection } from '../connection/connection';
import { setFormValidationErrors } from '../common/Utils';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// const schema: FormSchema = [
//   {
//     id: 'username',
//     name: 'Email',
//     type: 'string',
//   },
//   {
//     id: 'password',
//     name: 'Password',
//     type: 'password',
//   },
// ];

export const Login: FC = () => {
  const navigate = useNavigate();
  const connection = useConnection();
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const submit = useCallback(
    async (values: any) => {
      setLoading(true);
      try {
        const res = await connection.post('auth/login', values);
        connection.login(
          res.data.tokens.accessToken,
          res.data.tokens.refreshToken,
        );
        navigate(res.data.status === 'NEW' ? '/new-user' : '/webux');
      } catch (error: any) {
        if (!setFormValidationErrors(form, error)) {
          Modal.error({
            title: `${t('login.error')}`,
            content: `${t('login.loginError')}`,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [connection, form, navigate, t],
  );
  const schema = useMemo(() => {
    return [
      {
        id: 'email',
        name: `${t('login.email')}`,
        type: 'string',
      },
      {
        id: 'password',
        name: `${t('login.password')}`,
        type: 'password',
      },
    ];
  }, [t]);
  return (
    <div className="w-screen h-screen flex flex-col justify-center items-center">
      <div className="w-screen h-screen absolute overflow-clip hidden sm:block">
        <div className="bg-primary opacity-10 w-screen h-screen absolute overflow-hidden" />
        <div className="bg-primary opacity-15 w-[800px] h-[800px] absolute -left-[280px] -top-[280px]  rounded-full" />
        <div className="bg-primary opacity-15 w-[700px] h-[700px] absolute -left-[250px] -top-[250px] rounded-full" />
        <div className="bg-primary opacity-15 w-[600px] h-[600px] absolute -left-[220px] -top-[220px] rounded-full" />

        <div className="bg-primary opacity-15 w-[800px] h-[800px] absolute -right-[280px] -bottom-[280px]  rounded-full" />
        <div className="bg-primary opacity-15 w-[700px] h-[700px] absolute -right-[250px] -bottom-[250px] rounded-full" />
        <div className="bg-primary opacity-15 w-[600px] h-[600px] absolute -right-[220px] -bottom-[220px] rounded-full" />
      </div>

      <div className="flex justify-center sm:justify-between items-center w-screen xs:max-w-screen sm:max-w-[300px] lg:max-w-[700px] xl:max-w-[900px] h-[500px] sm:border sm:border-solid sm:border-gray-200 sm:shadow-lg rounded-lg sm:px-[100px] py-[50px] relative overflow-hidden bg-white">
        <div className="bg-primary opacity-15 w-[700px] h-[700px] absolute -right-[180px] rounded-full hidden lg:block" />
        <div className="bg-primary opacity-15 w-[700px] h-[700px] absolute -right-[250px] rounded-full hidden lg:block" />
        <div className="bg-primary opacity-15 w-[700px] h-[700px] absolute -right-[320px] rounded-full hidden lg:block" />
        <div className="w-full max-w-[300px] sm:w-[300px] flex flex-col p-4">
          <div className="w-full flex justify-center">
            <img src="/logo.png" className="h-[60px] w-[232px] w-auto" />
          </div>
          <Divider />
          <div className="font-bold text-xl text-center text-primary">
            {t('login.title')}
          </div>
          <Form form={form} layout="vertical" onFinish={submit}>
            <Form.Items schema={schema} />
            <Button
              className="w-full"
              loading={loading}
              type="primary"
              htmlType="submit"
            >
              {t('login.title')}
            </Button>
          </Form>
        </div>
        <div className="relative overflow-hidden hidden lg:block">
          <img src="/login.png" className="w-[300px]" />
        </div>
      </div>

      {/*<div className="h-[200px]"></div>*/}
    </div>
  );
};
